import React, { useEffect, useContext } from "react"
import { MuiThemeProvider } from "@material-ui/core/styles"
import { observer } from "mobx-react-lite"

import api from "./api"
import theme from "./style/theme"
import RoutesIndex from "./routes"
import { RootStoreContext } from "./stores/RootStore"
import { makeStyles } from "@material-ui/core/styles"
import Snackbar from "@material-ui/core/Snackbar"
import Alert from "@material-ui/lab/Alert"
import Backdrop from "@material-ui/core/Backdrop"
import CircularProgress from "@material-ui/core/CircularProgress"

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: 1,
  },
  spinner: {
    color: theme.palette.background.default,
  },
}))

const App = observer(() => {
  const rootStore = useContext(RootStoreContext)
  const utilityStore = rootStore.UtilityStore
  const classes = useStyles()

  useEffect(() => {
    async function stillAuthenticated() {
      const verifyToken = await api.verifyToken()
      if (verifyToken.ok) {
        rootStore.authStore.setIsAuthenticated(true)
      } else {
        rootStore.authStore.setIsAuthenticated(false)
      }
    }
    stillAuthenticated()
    //Suppress eslint error for []
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Hooks equivalent to "componentDidMount"

  if (rootStore.authStore.isAuthenticated === null) {
    return null
  }

  return (
    <MuiThemeProvider theme={theme}>
      <RoutesIndex />
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={utilityStore.snackbarState.open}
        autoHideDuration={6000}
        onClose={() => utilityStore.setSnackbarState("", { open: false })}
      >
        <Alert
          variant="filled"
          severity={utilityStore.snackbarState.severity}
          onClose={() => utilityStore.setSnackbarState("", { open: false })}
        >
          {utilityStore.snackbarState.message}
        </Alert>
      </Snackbar>
      <Backdrop open={utilityStore.loadingState} className={classes.backdrop}>
        <CircularProgress className={classes.spinner} />
      </Backdrop>
    </MuiThemeProvider>
  )
})

export default App
